import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { MapPin, Navigation, Smartphone, Monitor, List, FileText } from "lucide-react";
interface FloatingBadgeProps {
  icon: React.ElementType;
  text: string;
  className?: string;
  iconColorClass?: string;
}
const FloatingBadge = ({
  icon: Icon,
  text,
  className,
  iconColorClass
}: FloatingBadgeProps) => <div className={cn("absolute z-20 bg-background shadow-xl rounded-lg px-3 py-2 md:px-4 md:py-2.5 flex items-center gap-2 md:gap-3 text-xs md:text-sm font-medium text-foreground whitespace-nowrap border border-border/50", className)}>
    <div className={cn("p-1.5 rounded-md bg-muted", iconColorClass)}>
      <Icon className="w-3 h-3 md:w-4 md:h-4" />
    </div>
    {text}
  </div>;
export default function FeaturesHero() {
  return <section id="featureshero" className="bg-background pt-20 pb-16 lg:pt-32 lg:pb-24 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          <div className="max-w-2xl relative z-10">
            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground tracking-tight">
              Potpuno <span className="text-secondary">digitalno rješenje</span>{" "}
              za vašu tvrtku
            </h1>
            <p className="text-muted-foreground text-lg md:text-xl mt-6 mb-8 leading-relaxed">Mobileo je učinkovit i jednostavan softver za upravljanje radnom snagom, koji vam omogućuje automatizaciju svih operacija i praćenje u stvarnom vremenu svih aktivnosti vaših čuvara, čistača, voditelja i mobilnih timova</p>
            <div className="relative inline-block">
              <Button size="lg" className="rounded-lg px-8 text-base h-12" onClick={() => document.getElementById('success-path-form')?.scrollIntoView({
              behavior: 'smooth'
            })}>
                Zatraži demo
              </Button>
              
              <svg className="absolute -bottom-12 -right-16 w-24 h-24 text-secondary hidden md:block" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20 Q 40 80 90 40" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
                <path d="M80 35 L 90 40 L 85 50" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>

          
          <div className="relative w-full max-w-[500px] mx-auto lg:ml-auto aspect-square mt-8 lg:mt-0">
            
            <div className="absolute inset-4 md:inset-8 border-2 border-dashed border-muted-foreground/20 rounded-3xl z-0"></div>

            
            <div className="absolute top-12 right-12 w-4 h-4 bg-secondary rounded-lg z-0 opacity-80"></div>
            <div className="absolute bottom-8 left-1/2 w-3 h-3 bg-primary rounded-lg z-0 opacity-80"></div>

            
            <div className="absolute inset-0 z-10 flex items-end justify-center">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/hero_security_guard.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/hero_security_guard.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/hero_security_guard.png-wvc-sizes" alt="Security guard using mobile app" className="w-[85%] h-auto object-contain object-bottom drop-shadow-2xl" loading="eager" />
            </div>

            
            <FloatingBadge icon={MapPin} text="Karta aktivnosti" className="top-[10%] left-[-5%] md:left-[-15%] text-primary" iconColorClass="bg-primary/10 text-primary" />
            <FloatingBadge icon={Navigation} text="GPS praćenje" className="top-[30%] left-[-10%] md:left-[-25%] text-secondary" iconColorClass="bg-secondary/10 text-secondary" />
            <FloatingBadge icon={Smartphone} text="Kontrolne točke" className="top-[55%] left-[-5%] md:left-[-15%] text-primary" iconColorClass="bg-primary/10 text-primary" />
            <FloatingBadge icon={Monitor} text="Nadzor u stvarnom vremenu" className="top-[15%] right-[-10%] md:right-[-25%] text-secondary" iconColorClass="bg-secondary/10 text-secondary" />
            <FloatingBadge icon={List} text="Dnevnici aktivnosti" className="top-[45%] right-[-5%] md:right-[-15%] text-primary" iconColorClass="bg-primary/10 text-primary" />
            <FloatingBadge icon={FileText} text="Izvještaji" className="bottom-[20%] right-[-10%] md:right-[-20%] text-secondary" iconColorClass="bg-secondary/10 text-secondary" />
          </div>
        </div>
      </div>
    </section>;
}